import { useEffect, useState } from "react";
import { useGetFacultyByCourseIdQuery } from "@axio/graphql/generated/graphql";
import SearchListModal from "../../../components/common/SearchListModal/SearchListModal";

const RemoveFacultyFromCourseListContainer = ({
  visible,
  onClose,
  onAction,
  courseId,
}: {
  visible: boolean;
  onClose: () => void;
  onAction: (id: string | string[]) => void;
  courseId: string;
}) => {
  const [searchQuery, setSearchQuery] = useState("");

  const { data: facultyData, refetch: facultyRefetch } = useGetFacultyByCourseIdQuery({
    variables: {
      courseId: courseId,
      searchQuery,
    },
  });

  useEffect(() => {
    facultyRefetch();
  }, [searchQuery, courseId]);

  const list =
    facultyData?.getFacultyByCourseId?.data.faculties.map((faculty) => ({
      id: faculty.id,
      name: faculty.name,
    })) || [];

  return (
    <SearchListModal
      visible={visible}
      onClose={onClose}
      onAction={onAction}
      list={list}
      searchQuery={searchQuery}
      setSearchQuery={setSearchQuery}
      title={"Remove Faculty"}
      multiSelect={true}
      multiSelectConfirmLabel="Remove Selected"
    />
  );
};

export default RemoveFacultyFromCourseListContainer;
